"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultHeight = exports.dataTestId = exports.variantNaked = exports.dataTestIdForCharCount = exports.classes = void 0;
var classes = {
  container: 'bds-textarea-main-container',
  textareaLabel: 'bds-textarea-label',
  textareaLabelDisabled: 'bds-textarea-label-disabled',
  textareaHelperText: 'bds-textarea-helper-text',
  textareaHelperTextDisabled: 'bds-textarea-helper-text-disabled',
  textareaContainer: 'bds-textarea-container',
  textareaContainerDisabled: 'bds-textarea-container-disabled',
  textareaContainerErrorBorder: 'bds-textarea-container-error-border',
  textareaContainerFocus: 'bds-textarea-container-focus',
  textareaBox: 'bds-textarea-box',
  textareaBoxDisabled: 'bds-textarea-box-disabled',
  textareaBoxReadOnly: 'bds-textarea-box-read-only',
  errorMsgText: 'bds-error-msg-text',
  variantNaked: 'bds-naked',
  charLeftCount: 'bds-textarea-character-count-left-text'
};
exports.classes = classes;
var dataTestIdForCharCount = 'character-left-count-test-id';
exports.dataTestIdForCharCount = dataTestIdForCharCount;
var variantNaked = 'naked';
exports.variantNaked = variantNaked;
var dataTestId = 'textarea-test-id';
exports.dataTestId = dataTestId;
var defaultHeight = '104px';
exports.defaultHeight = defaultHeight;